/* globals $: true, window: true, document: true, INSTANT_URL: true, Codsec: true, PUBLIC_API_SERVER: true, USER_UUID: true */

function scrollToElement(el, ms) {
		var speed = (ms) ? ms : 600;
		$('html,body').animate({
			scrollTop: $(el).offset().top
		}, speed);
	};

$(document).ready(function() {
	// endsWith missing in IE
	if (typeof String.prototype.endsWith !== 'function') {
		String.prototype.endsWith = function(suffix) {
			return this.indexOf(suffix, this.length - suffix.length) !== -1;
		};
	}

	var queryString = window.location.search;
	var tabIndex = (queryString && queryString.toString().indexOf('credits')) !== -1 ? 3 : 0;
	$('.tab-link').eq(tabIndex).addClass('is-active').next().addClass('is-open').show();

  $('.accordion-tabs').on('click', 'li > a.tab-link', function(event) {
    if (!$(this).hasClass('is-active')) {
      event.preventDefault();
      var accordionTabs = $(this).closest('.accordion-tabs');
      accordionTabs.find('.is-open').removeClass('is-open').hide();

      $(this).next().toggleClass('is-open').toggle();
      accordionTabs.find('.is-active').removeClass('is-active');
      $(this).addClass('is-active');
    } else {
      event.preventDefault();
    }
  });


	var expanderTrigger = $(".js-expander-trigger");
	var expanderContent = $(".js-expander-content");
	$('.js-expander-trigger').click(function() {
		if ($(this).parent().hasClass("unpaid")) {
			scrollToElement('section.sell', 600);
		} else {
			$(this).toggleClass("expander-hidden");
		}
	});

	Codsec.appList.carousel();
	Codsec.appList.attachAllAppListener();
	Codsec.addApp.init();
	Codsec.userSettings.init();

	// $('.blockForm label input').on('input', function(e) {
	// 	val = howMany = $('.blockForm label').length;
	// 	$('.tempSubmit').remove();
	// 	if($(this).parents('label').is(':last-child')) { return; }
	// 	$(this).parents('label').after('<button type="submit" class="tempSubmit">Update Settings</button>');
	// });

	$("a.signin").click(function(e) {
		e.preventDefault();
		$(this).toggleClass('hover');
		$("nav div.signinform").fadeToggle(500);
		return false;
	});

	$(".nav-toggle").click(function() {
		$("nav .nav").fadeToggle(500);
		$(".top-menu").toggleClass("top-animate");
		$(".mid-menu").toggleClass("mid-animate");
		$(".bottom-menu").toggleClass("bottom-animate");
		if($(".top-menu").hasClass("top-animate")) {
			$("body").css('overflow-y','hidden');
		} else {
			$("body").css('overflow-y','scroll');
		}
	});

	var avatarEmail = $('nav .account span').text();
	$('nav .account span').html($.gravatar(avatarEmail, {secure: true}));

	$('#theForm input').keypress(function(e) {
		if (e.which == 13) {
			submit();
		}
	});
	$('#submitButton').click(function() {
		submit();
	});
	$('.results-table .arrow-wrapper').on('click', function() {
		var parentTr = $(this).closest('tr');
		$(this).toggleClass('active');
		parentTr.next().toggleClass('active');
	});
});

function validateEmail(email) {
	var re = /\S+@\S+\.\S+/;
	return re.test(email);
}

function submit() {
	var email = $('input[type=email]').val();
	if (validateEmail(email)) {
		document.getElementById('theForm').submit();
	} else {
		$('input[type=email]').focus();
	}
	return false;
}

function integrationClass(e) {
	$('.integrationLabel').each(function(e) {
		var value = $(this).children('input').val();
		if(value != '') {
			$(this).addClass('solid');
		} else {
			$(this).removeClass('solid');
		}
	});
}


function handlePurchaseUI() {
	$(".coupon-click").click(function() {
		$(this).remove();
	    $("label.coupon-label").addClass("show");
	    $('#coupon-code-input').focus();
	});

	$("html").click(function() {
		$("ul.userMenu").removeClass("show");
	});

	$("a.account").click(function(event){
		event.stopPropagation();
		$("ul.userMenu").addClass("show");
	});

	$('.qtyplus').click(function(e){
		e.preventDefault();
		fieldName = $(this).attr('field');
		var currentVal = parseInt($('input[name='+fieldName+']').val(), 10);
		if (!isNaN(currentVal)) {
			$('input[name='+fieldName+']').val(currentVal + 1);
		} else {
			$('input[name='+fieldName+']').val(0);
		}
	});

	$(".qtyminus").click(function(e) {
		e.preventDefault();
		fieldName = $(this).attr('field');
		var currentVal = parseInt($('input[name='+fieldName+']').val(), 10);
		if (!isNaN(currentVal) && currentVal > 0) {
			$('input[name='+fieldName+']').val(currentVal - 1);
		} else {
			$('input[name='+fieldName+']').val(0);
		}
	});
}

$(document).ready(handlePurchaseUI);
